import { Component,  inject, Input, OnInit } from "@angular/core";
import { faPerson} from "@fortawesome/free-solid-svg-icons";
import { TableConfiguration } from "../../../../../shared/components/paginated-data-table/paginated-table-configuration.model";
import { ActionButton } from "../../../../../shared/components/paginated-data-table/action-button.model";
import { SettingsService } from "../../../../../services/settings.service";
import { ActivatedRoute, Router } from "@angular/router";
import {Store} from "@ngrx/store";
import { StoreItemActions } from "../../../../../store/entities/store-item/store-item.actions";
import {StoreItem, StoreItemEntity} from "../../../../../store/entities/store-item/store-item.model";
import { NotificationService } from "../../../../../services/notification.service";
import { AppState } from "../../../../../store";
import {WarehouseAssignPersonComponent} from "./warehouse-assign-person/warehouse-assign-person.component";
import {
  GET_ASSIGNED_PERSON_IN_WAREHOUSE, REMOVE_ASSIGNED_PERSON_FROM_WAREHOUSE
} from "../../../../../store/entities/warehouse-management/warehouse-assignee/warehouse-assignee.graphql";
import {AccountTypesChoices, User} from "../../../../../store/entities/user-management/users/users.model";
import {
  WarehouseAssignedPersons
} from "../../../../../store/entities/warehouse-management/warehouse-assignee/warehouse-assignee.model";
import { SystemUser } from "../../../../../store/entities/system-configurations/temp-fcrs/system-user/system-user.model";
import { WarehouseTransferPersonComponent } from "./warehouse-transfer-person/warehouse-transfer-person.component";
import { NgxPermissionsService } from "ngx-permissions";

@Component({
  selector: "app-warehouse-assignee-list",
  templateUrl: "./warehouse-assignee-list.component.html",
  styleUrl: "./warehouse-assignee-list.component.scss",
})
export class WarehouseAssigneeListComponent implements OnInit {
  private settingService: SettingsService = inject(SettingsService);
  private router: Router = inject(Router);
  private activeRoute: ActivatedRoute = inject(ActivatedRoute);

  private notificationService: NotificationService =
  inject(NotificationService);
  @Input() refresh

  constructor(private store: Store<AppState>) {}
  upsertAction = StoreItemActions.upsertStoreItem;
  removeAction = StoreItemActions.deleteStoreItem;

  buildingData;
  query;
  addPermission: string[] = ["can_add_warehouse_users"];
  refreshDataTable: boolean = false;
  additionalVariables = {};
  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: "userFullName", label: "Name" }
    ],
    tableCaption: "",
    showNumbers: true,
    tableNotifications: "Notification",
    showSearch: true,
    useFullObject: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    doneLoading: false,
    deleting: {},
    active: {},
    hideExport: true,
    customPrimaryMessage: "Activate",
    empty_msg: "No data found",
  };

  actionButtons: ActionButton[] = [
    {
      id: "delete",
      label: "Delete",
      title: "Delete",
      class: "",
      icon: "delete",
      action: "delete",
      confirm_first: false,
      loading_message: "",
    },
    {
      id: "transfer",
      label: "Transfer",
      title: "Transfer",
      class: "",
      icon: "compare_arrows",
      action: "transfer",
      confirm_first: false,
      loading_message: "",
    },
        {
      id: "unassignWarehouse",
      label: "Unassign",
      title: "Unassign Warehouse",
      class: "",
      icon: "remove_circle",
      action: "unassignWarehouse",
      confirm_first: true,
      loading_message: "",
    }

    
  ];

  permissions = {
    delete: ["can_remove_warehouse_users"],
    transfer: ["can_transfer_warehouse_users"],
      unassignWarehouse: ["can_remove_warehouse_users"],
  };
  routeSub: any;
  selectedUuid: string;




  ngOnInit() {
    this.query = GET_ASSIGNED_PERSON_IN_WAREHOUSE;

    this.routeSub = this.activeRoute.queryParams.subscribe((items) => {
      this.selectedUuid = items["id"] ?? "";
      this.changeFilters({warehouseUniqueId:items['id']})
    });
    this.additionalVariables = {
      pageNumber:1,
      itemsPerPage:10,
      warehouseUniqueId: this.selectedUuid,
    };
  }

  changeFilters(newFilters){
    this.additionalVariables = newFilters
  }
  

  mapFunction(warehouseAssignedPersons) {

      return {
        ...warehouseAssignedPersons,
        userFullName: `${warehouseAssignedPersons?.userList[0]?.firstName} ${warehouseAssignedPersons?.userList[0].lastName}`,
        id: warehouseAssignedPersons.uniqueId
        // ...warehouseAssignedPersons,
        // userFullName: ` ${item?.firstName} ${item?.lastName} ${ item?.accountType === AccountTypesChoices.WAREHOUSE_MANAGER ? '(Manager)' : ''}`,
        // userFullName: ` ${warehouseAssignedPersons?.firstName} ${warehouseAssignedPersons?.lastName}`,
      }
  }

  onAdd(data=null) {
    
    this.settingService.openDialogModal({
      component: WarehouseAssignPersonComponent,
      data:{data,
      id:this.selectedUuid}
    });
  }

  onDelete = (evt) => {
    this.notificationService
        .confirmation({ message: "Are you sure you want to delete?" })
        .then((result) => {
          if (result){
            this.store.dispatch(
                StoreItemActions.removeStoreItem({
                  entity: StoreItemEntity.warehouseAssignee,
                  id: evt.id,
                  input: { uniqueId: evt.uniqueId },
                  mutation: REMOVE_ASSIGNED_PERSON_FROM_WAREHOUSE,
                })
            );
          }
          else{

          }
        });
  };

   onTransfer = (data) => {
    this.settingService.openDialogModal({
      component: WarehouseTransferPersonComponent,
      data:{
        data,
        warehouseUniqueId:this.selectedUuid,
        userUniqueId: data?.data.userList[0].uniqueId,
      }
    });
    
   }

  onCustomAction(evt: any) {

    this.buildingData = evt.value
    switch (evt?.action) {
      case "delete":
        this.onDelete(evt.value)
        break;
             case "unassignWarehouse":
        this.onDelete(evt.value); // reuse onDelete for unassigning
        break;
      case "transfer":
        this.onTransfer(evt.value)
    }
  }

  getData(data: StoreItem[]) {
    this.store.dispatch(StoreItemActions.loadStoreItems({storeItems: data, entity: StoreItemEntity.warehouseAssignee}))
  }
  protected readonly faPerson = faPerson;
}
